document.addEventListener('DOMContentLoaded', () => {
  window.isZoomed = false;
  let zoomIsOpen = false;
  let dragStartTime;
  let mouseDownFunction;
  let clickOccurred = false; // Flag to track if a click event has occurred before a touch event
  let currentLgImgWrap; // Store the current lgImgWrap for touch event handling

  const zoomElement = el => {
    el.classList.add('zoomed');
    el.querySelector('.lg-object').style.cursor = 'grab';
    document.addEventListener('mousedown', mouseDownFunction);
  };

  const unzoomElement = el => {
    el.classList.remove('zoomed');

    el.querySelector('.lg-object').style.cursor =
      'url("https://cdn.shopify.com/s/files/1/0302/0770/5226/files/plus-icon.svg?v=1687529741") 24 24, auto';
    // Remove the mousedown listener when the element is unzoomed
    document.removeEventListener('mousedown', mouseDownFunction);
    // Reset position
    el.style.left = '0px';
    el.style.top = '0px';
  };

  document.addEventListener('click', e => {
    if (
      e.target.classList.contains('lg-actions') ||
      e.target.classList.contains('lg-close') ||
      e.target.classList.contains('lg-next') ||
      e.target.classList.contains('lg-prev') ||
      e.target.classList.contains('lg-thumb-outer')
    )
      return;

    zoomIsOpen = document.querySelector('.lg-thumb-open');
    let lgItems = Array.from(document.querySelectorAll('.lg-item'));

    clickOccurred = true;

    if (!zoomIsOpen) return;

    lgItems.forEach(item => {
      if (item.classList.contains('lg-current')) {
        let lgImgWrap = item.querySelector('.lg-img-wrap');
        const elapsedTime = Date.now() - dragStartTime;

        currentLgImgWrap = lgImgWrap;

        if (isDragging && !window.isZoomed) {
          window.isZoomed = false;
        } else {
          if (!window.isZoomed) {
            isZoomed = true;
            zoomElement(lgImgWrap);
          } else {
            console.log(isDragging);
            if (!isDragging) {
              isZoomed = false;
              unzoomElement(lgImgWrap);
            }
          }
        }

        lgImgWrap.ondragstart = () => false;
      }
    });
  });

  const startDragging = ({ el, event, zoomIsOpen, isZoomed }) => {
    if (!zoomIsOpen && !isZoomed) return;

    let startX = event.pageX - el.offsetLeft;
    let startY = event.pageY - el.offsetTop;

    el.querySelector('.lg-object').style.cursor = 'grabbing';

    let onMouseMove = e => {
      el.style.left = `${e.pageX - startX}px`;
      el.style.top = `${e.pageY - startY}px`;
    };

    document.addEventListener('mousemove', onMouseMove);

    document.addEventListener('mouseup', () => {
      currentLgImgWrap.querySelector('.lg-object').style.cursor = 'gab';
      document.removeEventListener('mousemove', onMouseMove);
    });
  };

  mouseDownFunction = function (e) {
    dragStartTime = Date.now();

    if (!clickOccurred && !zoomIsOpen && !isZoomed) {
      return; // Ignore touch events if no click event occurred
    }

    startDragging({ el: currentLgImgWrap, event: e, zoomIsOpen, isZoomed: window.isZoomed });

    // Add a mouseup event listener to detect when dragging stops
    window.addEventListener('mouseup', onMouseUp);

    // Function to handle mousemove event
    function onMouseMove() {
      // Update the cursor to "grabbing"
      document.body.style.cursor = 'grabbing';
      dragStartTime = Date.now();
    }

    // Function to handle mouseup event
    function onMouseUp() {
      // Remove the mousemove and mouseup event listeners
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);

      // Calculate the time since the last mousemove event
      const timeSinceLastMove = Date.now() - dragStartTime;

      // If the user has not moved the mouse for a certain duration, set the cursor to "grab"
      if (timeSinceLastMove >= 90) {
        window.isZoomed = true;
        currentLgImgWrap.querySelector('.lg-object').style.cursor = 'grab';
      }
    }
  };
});

// get js-product-gallery="featuredImage"
const featuredImages = Array.from(
  document.querySelectorAll('[js-product-gallery="featuredImage"]')
);

// add click event listener to featuredImage

function setCursor(imagesArray) {
  imagesArray.forEach(image => {
    image.addEventListener('click', e => {
      // change cursor
      document.body.style.cursor =
        'url("https://cdn.shopify.com/s/files/1/0302/0770/5226/files/plus-icon.svg?v=1687529741") 24 24, auto';
    });
  });
}

// on esc key press, change cursor back to default
document.addEventListener('keydown', e => {
  if (e.key === 'Escape') {
    document.body.style.cursor = 'default';
  }
});

// on .lg-close click, change cursor back to default
document.addEventListener('click', e => {
  if (e.target.classList && e.target.classList.contains('lg-close')) {
    document.body.style.cursor = 'default';
  }
});

let dragStartTime = 0;
let startX = 0;
let startY = 0;
let isDragging = false; // Flag to track dragging state

document.addEventListener('mousedown', e => {
  startX = e.clientX;
  startY = e.clientY;
  dragStartTime = Date.now();
  isDragging = false; // Reset the flag on mousedown
});

document.addEventListener('mousemove', e => {
  if (isDragging) {
    // Already determined as dragging, no need to check further
    return;
  }

  const endX = e.clientX;
  const endY = e.clientY;

  const distance = Math.sqrt((endX - startX) ** 2 + (endY - startY) ** 2);

  if (distance > 10) {
    isDragging = true; // Set the flag when dragging starts
  }
});
